// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".home-conversion-guide{box-shadow:0 3px 24px rgba(0,0,0,.08);border-radius:4px;color:#282f3a}.home-conversion-guide * a{color:#282f3a;text-decoration:underline}.home-conversion-guide__instructions{margin-bottom:3em}.home-conversion-guide__wrapper{padding:45px 30px}@media only screen and (max-width: 768px){.home-conversion-guide__wrapper{padding:20px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
